import promotion from "./promotion.component";
import promotionUrls from "./promotion.urls";
import PromotionTransforms from "./promotion.transforms";

const promotionModule = angular
  .module("app.components.promotion", [])
  .component("promotionPage", promotion)
  .service("PromotionTransforms", PromotionTransforms)
  .config(promotionUrls);

export default promotionModule;



// WEBPACK FOOTER //
// ./src/pages/promotion/promotion.module.js